<template>
  <div></div>
</template>

<script>
  import {mapActions} from 'vuex';
  export default {
    name: 'Logout',
    data() {
      return {};
    },

    async mounted() {
      this.logout();
      this.$router.push('/login');
    },

    methods: {
      ...mapActions([
        'logout',
      ]),
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Logout.vue